import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaved = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 24,
		fill: "#7FE718",
		fillOpacity: .2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32 18L21 29L16 24",
		stroke: "#7FE718",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSaved;
